var React = require('react');

var Video = React.createClass({
    
    getThumbnailPath: function(thumbnailUrl){
        var thumbnailPath = '';
        
        if(typeof thumbnailUrl === 'string'){
            thumbnailPath = '/media/motion/';
            thumbnailPath += thumbnailUrl.split('http://media.video-cdn.espn.com/images/')[1];
        }
        return thumbnailPath;
    },
    
    formatDuration: function(duration){
        var mins = (duration / 60);
        var secs = (duration%60);
                
        return Math.floor(mins) + ':' + secs;
    },
    
    render : function(){
        
        var thumbnailPath = this.getThumbnailPath(this.props.thumbnail);
        var duration = this.formatDuration(this.props.duration);
        
        var videoHtml = (
            '<!--[if IE 9]><video style="display: none;"><![endif]-->' +
            '<source srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=375&h=150&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin 2x" data-srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=375&h=150&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin 2x" media="(max-width: 375px)"/>' +
            '<source srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin 2x" data-srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin 2x" media="(min-width: 376px)"/>' +
            '<!--[if IE 9]></video><![endif]-->' +
            '<img src="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin" data-default-src="http://a.espncdn.com' + thumbnailPath + '" className=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="944"/>'
        );
        
        videoHtml = (
            '<!--[if IE 9]><video style="display: none;"><![endif]-->' +
            '<source srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" data-srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" media="(max-width: 413px)" />' + 
            '<source srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" data-srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" media="(min-width: 414px)" />' + 
            '<!--[if IE 9]></video><![endif]--><img src="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin" data-default-src="http://a.espncdn.com' + thumbnailPath + '" class=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="272" />'
        );
        
        return (
    		<figure className="feed-item-figure video " data-source="espn" data-video="native,640,360,13572065">
    			<div className="img-wrap">
    				<a name="&lpos=" href={this.props.href ? this.props.href + "&ex_cid=espnapi_internal" : '#'} data-sport="rugby">
    					<picture dangerouslySetInnerHTML={{__html : videoHtml}}>
    					</picture>
    				</a>
    				<span className="video-play-button ">Play<span className="video-length">{duration}</span></span>
    			</div>
    		</figure>
        );
    }
});

module.exports = Video;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/Video.jsx
 **/